var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"size":"xl","header-close-content":"×","hide-footer":true,"id":"fileModal","title":"Карта крою"}},[_c('embed',{attrs:{"src":_vm.pdfFile,"type":"application/pdf"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }